export default {
  justNow: '刚刚',
  minutesAgo: '{n}分钟前',
  hoursAgo: '{n}小时前',
  daysAgo: '{n}天前',
  monthsAgo: '{n}个月前',
  yearsAgo: '{n}年前',
}
